<template>

<app-table empty-message="This attendee has not submitted any events." :empty="!items.length">

	<app-table-head :layout="layout">

		<app-table-column />

		<app-table-column text="Name" />

		<app-table-column text="Room" />

		<app-table-column text="Submitted on" />

	</app-table-head>

	<app-table-body>

		<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-label :text="$constants.schedule.suggestions.statusName[item.status]" :type="$constants.schedule.suggestions.statusTheme[item.status]" :subtext="item.reference" />
			
            <app-table-cell-text :text="item.name" />
			
            <app-table-cell-text v-if="item.room" :text="item.room.name" />
			
            <app-table-cell-text v-if="!item.room" text="-" />
			
			<app-table-cell-text :text="item.date.created | localDate('MM/DD/YYYY h:mma')" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: '120px auto 360px 180px'
		}
	
	},

	methods: {

		onEditClick: function(item) {
		
			this.$router.push({
				name: 'Convention.Schedule.Suggestions.Edit', 
				params: {
					id: item
				}
			})
		
		}
    
    }

}

</script>

<style scoped>

</style>